import { Component, inject, input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgencyAddressModel } from 'src/app/account/agency-address';
import { SocialMedia } from 'src/app/agency-branding';

@Component({
  selector: 'app-bottom-navigation',
  templateUrl: './bottom-navigation.component.html',
  styleUrls: ['./bottom-navigation.component.scss'],
})
export class BottomNavigationComponent implements OnInit {
  readonly #activatedRoute = inject(ActivatedRoute);

  protected bottomNavigationDetails = input<AgencyAddressModel>();
  protected socialMedia = input<SocialMedia>();

  hostName: string;
  applicantId: number;
  isMultipleAccountPage: boolean;
  contactUsLink: string;
  year: number;

  constructor() {
    this.hostName = window.location.pathname.split('/')[3];
    this.applicantId = +this.#activatedRoute.snapshot.paramMap.get('applicantId');
  }

  ngOnInit(): void {
    this.contactUsLink = `/EzLynxCustomerService/${this.hostName}/HelpCenter/HelpCenter/Index/${this.applicantId}`;
    this.year = new Date().getFullYear();
  }
}
